import Image from "next/image";
import styled, { keyframes } from "styled-components";

export const fadeIn = keyframes`
  to {
    opacity: 1;
  }
`;

export const Section = styled.section`
  padding-top: 4rem;
  padding-bottom: 4rem;
  background-color: #f3f4f6;

  @media (min-width: 768px) {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: 640px) {
    max-width: 640px;
  }

  @media (min-width: 768px) {
    max-width: 768px;
  }

  @media (min-width: 1024px) {
    max-width: 1024px;
  }

  @media (min-width: 1280px) {
    max-width: 1280px;
  }

  @media (min-width: 1536px) {
    max-width: 1536px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 4rem;
  align-items: center;

  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  animation: ${fadeIn} 1s forwards;
`;

export const GradientOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom right,
    rgba(0, 123, 255, 0.1),
    rgba(32, 201, 151, 0.1)
  );
  border-radius: 1rem;
  transform: rotate(-3deg) scale(0.98);
`;

export const ImageContainer = styled.div`
  position: relative;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const TextContainer = styled.div`
  max-width: 36rem;
`;

export const Tag = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: #e0f2fe;
  color: ${({ theme }) => theme.colors.primary[3]};
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  font-size: 2.25rem;
  line-height: 40px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primaryText[9]};
  margin-bottom: 1.5rem;

  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
`;

export const Description = styled.p`
  font-size: 1.125rem;
  color: ${({ theme }) => theme.colors.primaryText[9]};
  margin-bottom: 2rem;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-left: 0;
  margin-bottom: 2.5rem;
`;

export const ListItem = styled.li<{ $animationDelay?: string }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  animation: ${fadeIn} 1s forwards;
  animation-delay: ${(props) => props.$animationDelay || "0ms"};
`;

export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  padding: 1rem 1.5rem;
  border-radius: 9999px;
  transition: background 0.3s ease;

  &.primary {
    background-color: ${({ theme }) => theme.colors.primary[3]};
    border: none;
    color: ${({ theme }) => theme.colors.primaryText.white};
    &:hover {
      background-color: ${({ theme }) => theme.colors.primary[4]};
    }
  }
`;

export const IconWrapper = styled.div`
  background-color: #e0f2fe;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  padding: 0.25rem;
  margin-top: 0.125rem;
`;

export const ListText = styled.span`
  color: ${({ theme }) => theme.colors.primaryText[8]};
`;
